import axios from 'axios'

const RESET = 'RESET'

const BASE_URL = 'api/StationManagement'
const MERGE_URL = `${BASE_URL}/Merge`
const EDIT_CATEGORY_URL = `${BASE_URL}/EditStationCategory`

const EDIT_CONTINUOUS_CATEGORY_URL = 'api/ContinuousStationCategory/EditContinuousCategory'

let initialState = () => ({})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async mergeStations(_, payload) {
      try {
        let response = await axios.post(MERGE_URL, payload)
        return response.data
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async editStationCategory(_, payload) {
      try {
        let response = await axios.post(EDIT_CATEGORY_URL, payload)
        return response.data
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async editContinuousStationCategory(_, payload) {
      try {
        await axios.post(EDIT_CONTINUOUS_CATEGORY_URL, payload)
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
  },
  mutations: {
    [RESET](state) {
      state.configurations = initialState.configurations
    },
  },
}